import Keycloak from "keycloak-js";

let kcconfig = {
  realm: process.env.REACT_APP_KEYCLOAK_REALM,
  "auth-server-url": process.env.REACT_APP_KEYCLOAK_URL,
  url: process.env.REACT_APP_KEYCLOAK_URL,
  resource: process.env.REACT_APP_KEYCLOAK_CLIENT,
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT,
  "public-client": true,
  "confidential-port": 0,
};

let _kc = new Keycloak(kcconfig);

/**
 * Initializes Keycloak instance and calls the provided callback function if successfully authenticated.
 *
 * @param onAuthenticatedCallback
 */

const initKeycloak = (onAuthenticatedCallback) => {
  const currentPath = window.location.pathname + window.location.search;

  const isGenericPath =
    currentPath === "/" ||
    currentPath.startsWith("/login") ||
    currentPath.trim() === "";

  const redirectUri = isGenericPath
    ? window.location.origin + "/home-engenheiro"
    : window.location.origin + currentPath;

  _kc
    .init({
      onLoad: "login-required",
      checkLoginIframe: false,
      silentCheckSsoRedirectUri:
        window.location.origin + "/silent-check-sso.html",
      pkceMethod: "S256",
      responseMode: "query",
      redirectUri,
    })
    .then((authenticated) => {
      if (authenticated) {
        localStorage.setItem("token", _kc.token);

        localStorage.removeItem("materialPartDesc");
        localStorage.removeItem("materialPartNumber");
        localStorage.removeItem("selectValue");
        localStorage.removeItem("selectedStatus");
        localStorage.removeItem("selectedCenter");
        localStorage.removeItem("startDate");
        localStorage.removeItem("endDate");
        localStorage.removeItem("classificationQuizStartDate");
        localStorage.removeItem("classificationQuizFinishDate");
        localStorage.removeItem("classificationApprovalStartDate");
        localStorage.removeItem("classificationApprovalEndDate");
        localStorage.removeItem("centerFilter");
        localStorage.removeItem("emitentePartNumber");
        localStorage.removeItem("selectedFlag");

        if (
          window.location.search.includes("code=") ||
          window.location.hash.includes("code=")
        ) {
          window.history.replaceState(
            {},
            document.title,
            currentPath || "/home-engenheiro"
          );
        }
      }

      if (typeof onAuthenticatedCallback === "function") {
        onAuthenticatedCallback();
      }
    })
    .catch(console.error);
};

const doLogin = () => {
  if (_kc && typeof _kc.login === "function") {
    return _kc.login();
  } else {
    console.warn("Keycloak não inicializado ou login não disponível.");
    return Promise.reject("Keycloak não inicializado");
  }
};

const doLogout = () => {
  if (_kc && typeof _kc.logout === "function") {
    return _kc.logout();
  } else {
    console.warn("Keycloak não inicializado ou logout não disponível.");
    return Promise.reject("Keycloak não inicializado");
  }
};

const getToken = () => _kc.token;

const getTokenParsed = () => _kc.tokenParsed;

const isLoggedIn = () => !!_kc.token;

const updateToken = (successCallback) =>
  _kc
    .updateToken(5)
    .then(successCallback)
    .catch(() => {
      return doLogin();
    });

const getUsername = () => _kc.tokenParsed?.preferred_username;

const hasRole = (roles) => roles.some((role) => _kc.hasRealmRole(role));

const UserService = {
  initKeycloak,
  doLogin,
  doLogout,
  isLoggedIn,
  getToken,
  getTokenParsed,
  updateToken,
  getUsername,
  hasRole,
};

export default UserService;
